<template>
  <MCard class="product-card-skeleton h-100">
    <!-- Bild Skeleton -->
    <MSkeletonLoader type="image" :height="200" />

    <!-- Content Skeleton -->
    <MCardText class="pb-2">
      <MSkeletonLoader type="text" :width="80" class="mb-1" />
      <MSkeletonLoader type="text" class="mb-0" />
      <MSkeletonLoader type="text" width="70%" />
    </MCardText>

    <!-- Preis + Button Skeleton -->
    <MCardActions class="px-4 pb-4 pt-0">
      <MSkeletonLoader type="text" :width="80" />
      <span class="m-spacer" />
      <MSkeletonLoader type="button" :width="100" />
    </MCardActions>
  </MCard>
</template>

<style scoped>
.product-card-skeleton { overflow: hidden; }
</style>
